import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Gauge, AlertTriangle } from 'lucide-react';
import SubNav from './components/SubNav';
import ProjectPerformance from './ProjectPerformance';
import ProjectTechnicalErrors from './ProjectTechnicalErrors';

/**
 * Onglet fusionné « Performance & technique » : scores PageSpeed + points à corriger.
 */
export default function ProjectPerformanceTab({ defaultSub = 'performance' }) {
  const [params, setParams] = useSearchParams();
  const sub = params.get('sub') || defaultSub;
  const setSub = (key) => {
    const next = new URLSearchParams(params);
    next.set('sub', key);
    setParams(next, { replace: true });
  };

  return (
    <div className="flex flex-col gap-4">
      <SubNav
        active={sub}
        onChange={setSub}
        items={[
          { key: 'performance', label: 'Performance', icon: Gauge },
          { key: 'errors', label: 'Points à corriger', icon: AlertTriangle },
        ]}
      />
      {sub === 'errors' ? <ProjectTechnicalErrors /> : <ProjectPerformance />}
    </div>
  );
}
